// extracted by mini-css-extract-plugin
export var dark = "t_sy";
export var darkcookie = "t_sz";
export var tintedcookie = "t_sB";
export var regularcookie = "t_sC";
export var darkbase = "t_sD";
export var tintedbase = "t_sF";
export var regularbase = "t_sG";
export var darkraw = "t_sH";
export var tintedraw = "t_sJ";
export var regularraw = "t_sK";
export var darkchick = "t_sL";
export var tintedchick = "t_sM";
export var regularchick = "t_sN";
export var darkherbarium = "t_sP";
export var tintedherbarium = "t_sQ";
export var regularherbarium = "t_sR";
export var darkholiday = "t_sS";
export var tintedholiday = "t_sT";
export var regularholiday = "t_sV";
export var darkoffline = "t_sW";
export var tintedoffline = "t_sX";
export var regularoffline = "t_sY";
export var darkorchid = "t_sZ";
export var tintedorchid = "t_s0";
export var regularorchid = "t_s1";
export var darkpro = "t_s2";
export var tintedpro = "t_s3";
export var regularpro = "t_s4";
export var darkrose = "t_s5";
export var tintedrose = "t_s6";
export var regularrose = "t_s7";
export var darktimes = "t_s8";
export var tintedtimes = "t_s9";
export var regulartimes = "t_tb";
export var darkwagon = "t_tc";
export var tintedwagon = "t_td";
export var regularwagon = "t_tf";